// Constant: Environment > Environment
const ENVIRONMENT = import.meta.env.MODE

// Constant: Environment > Media URL
const MEDIA_URL = 'https://res.cloudinary.com/ozanilbey'

// Constant: Environment > Root URL
const ROOT_URL = 'https://ozanilbey.com'

// Export
export {
  ENVIRONMENT,
  MEDIA_URL,
  ROOT_URL
}
